import { SortQualifier } from '@core/filters/path-filter/dsl/search-bar';
import { FilterVocabulary } from '@core/filters/path-filter/vocabulary/vocabulary';

/** What a `sort:edge.leaf` qualifier lacks for the data layer to accept it, or `null`. */
export function sortQualifierIssue(
  sort: SortQualifier,
  vocabulary: FilterVocabulary
): string | null {
  if (!sort.association) return null;
  const association = vocabulary.association(sort.association.edge);
  if (!association) return 'a related entity of this table before `.`';
  if (!association.sortableLeaves.includes(sort.field)) {
    return `a field \`${association.edge}\` can be sorted on`;
  }
  if (association.cardinality === 'many' && !sort.association.aggregate) {
    return '`-min` or `-max`, since several related rows could decide the order';
  }
  return null;
}
